import angular from 'angular';

class asNavBar {
    constructor() {
        this.showComponent = true;
    }

    show() {
        this.showComponent = true;

        return this;
    }

    hide() {
        this.showComponent = false;

        return this;
    }
}

export default angular.module('asNavBar').service('asNavBarService', asNavBar);



// WEBPACK FOOTER //
// ./modules/shared/asNavBar/asNavBar.service.js